import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { applyMiddleware, createStore, compose } from "redux";
import thunk from "redux-thunk";
import reducer from "./redux/reducers";
import { Provider, useDispatch } from "react-redux";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { store } from "./redux/store";
import axios from "axios";
import Helmet from "react-helmet";
import { ThemeProvider } from "@mui/material";
import { logout } from "./redux/actions/auth";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
// import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <HashRouter>
          <App />
        </HashRouter>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
